import { defineMessages } from "react-intl";

export const giftCardExportDialogMessages = defineMessages({
  title: {
    id: "DQJnB4",
    defaultMessage: "Export Gift Card Codes",
    description: "gift card export dialog title",
  },
  exportTypeLabel: {
    id: "3kwdxJ",
    defaultMessage: "gift cards",
    description: "gift card export type label",
  },
  confirmButtonLabel: {
    id: "CRAfpd",
    defaultMessage: "Export codes",
    description: "gift card export dialog confirm button label",
  },
  successAlertDescription: {
    id: "bDHiYK",
    defaultMessage:
      "We are currently exporting your gift card codes. As soon as your file is available it will be sent to your email address",
    description: "gift card export success alert description",
  },
  successAlertTitle: {
    id: "YEpYMB",
    defaultMessage: "Exporting CSV",
    description: "gift card export csv success alert title",
  },
  exportNote: {
    id: "dsJ+Wv",
    defaultMessage: "Note: Only active and not used gift cards will be expored",
    description: "note on export gift cards",
  },
});
